<awair-canvas-map *ngIf="mapUrl != null"
                  [imgSrc]="mapUrl"
                  (emitInitializedVariables)="initDeviceMarkers($event)"
                  (changeImagePosition)="onChangeImagePosition($event)"
                  (changeZoomRatio)="onChangeZoomRatio($event)">
</awair-canvas-map>
<!-- This is where markers will be in -->
<ng-template #markerAnchor></ng-template>
